import { render } from "./index_1.vue?vue&type=template&id=55855858&scoped=true"
import script from "./index_1.vue?vue&type=script&lang=js"
export * from "./index_1.vue?vue&type=script&lang=js"

import "./index_1.vue?vue&type=style&index=0&id=55855858&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-55855858"

export default script